export default __webpack_public_path__ + "static/media/snapchat.6ec189cc.svg";